const state = {
  guide_book: null,
  guide_book_detail: null
};

export default state;
